import { createApi } from '@reduxjs/toolkit/query/react';

import { ISubscriptionPlan } from '../../types/interfaces/subscription-plan';
import { ISubscriptionRestriction } from '../../types/interfaces/subscription-restriction';
import { HTTP_METHOD, REDUX_CACHE, SUBSCRIPTIONS } from '../constants';
import * as endpoints from '../endpoints';
import {
  TransformedErrorResponseWithNotification,
  getBaseQuery,
  getListProvidesTags,
} from '../generic';

export const subscriptionsApi = createApi({
  reducerPath: 'subscriptionsApi',
  tagTypes: [
    SUBSCRIPTIONS.PLANS,
    REDUX_CACHE.ABORT_INVALIDATION,
    REDUX_CACHE.LIST,
  ],
  baseQuery: getBaseQuery(),
  // global configuration for the api
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getPlansApi: builder.query<ISubscriptionPlan[], void>({
      keepUnusedDataFor: 3600,
      query() {
        return {
          url: endpoints.Subscriptions.PLANS,
          method: HTTP_METHOD.GET,
        };
      },
      providesTags: (result) =>
        getListProvidesTags(result, SUBSCRIPTIONS.PLANS),
      ...TransformedErrorResponseWithNotification(),
    }),
    getRestrictionsApi: builder.query<ISubscriptionRestriction[], void>({
      keepUnusedDataFor: 3600,
      query() {
        return {
          url: endpoints.Subscriptions.RESTRICTIONS,
          method: HTTP_METHOD.GET,
        };
      },
      providesTags: (result) =>
        getListProvidesTags(result, SUBSCRIPTIONS.RESTRICTIONS),
      ...TransformedErrorResponseWithNotification(),
    }),
  }),
});

export const {
  useGetPlansApiQuery: useGetPlans,
  useLazyGetPlansApiQuery: useLazyGetPlans,
  useGetRestrictionsApiQuery: useGetRestrictions,
} = subscriptionsApi;
